export default __webpack_public_path__ + "static/media/team_1.2b938315.jpg";